import { TransactionResult } from '../types/TransactionResult'
import Money from '../types/Money'
import api from './api'

export const payApple = async (
    paymentPageId: string,
    extraFieldsData: Record<string, string>,
    money?: Money,
): Promise<TransactionResult> => {
    return await api('/api/payment-page/pay/apple', {
        paymentPageId: paymentPageId,
        ...money ? {
            money: {
                amount: parseFloat(money.amount) * 100,
                currency: money.currency,
            }
        } : {},
        extraFields: extraFieldsData,
    }) as TransactionResult
}

export const validateMerchantSession = async (
    paymentPageId: string,
    transactionId: number,
    validationUrl: string,
): Promise<any> => {
    return await api(`/api/payment-page/pay/apple/validate`, { paymentPageId, transactionId, validationUrl })
}

export const sendAppleToken = async (
    paymentPageId: string,
    transactionId: number,
    token: any,
): Promise<TransactionResult> => {
    return await api<TransactionResult>(`/api/payment-page/pay/apple/token`, {paymentPageId, transactionId, token})
}
